// Результат постраничной разметки для интерфейса: листы основного текста, номера страниц заголовков (оглавление),
// листы перед текстом (титул, задание, лист замечаний, реферат, оглавление), текущая страница курсора.
import { createStore, useStore } from 'zustand';

export interface PageView {
  /** номер страницы в документе (с учётом листов перед текстом) */
  n: number;
  /** экранный низ последней строки на листе (px без масштаба, от верха листа) */
  lastBottom: number;
  /** сноски страницы: id узлов */
  fns: string[];
  fnH: number;
  /** продолжение таблицы: номер, окончание */
  cont?: { num: string; final: boolean };
  /** начало текста страницы (для навигатора) */
  snippet: string;
  /** позиция ProseMirror начала страницы */
  pos: number;
}

/** Закрыть рамку листинга в промежутке между листами (как в Word: рамка не продолжается через разрыв страницы) */
export interface Mask { top: number; bottom: number; left: number; width: number }

export interface FrontSheet { id: string; pages: number; numbered: boolean }

export interface PagesState {
  /** режим «Разметка страницы» включён и разметка посчитана */
  ready: boolean;
  main: PageView[];
  front: FrontSheet[];
  /** всего листов перед основным текстом */
  frontCount: number;
  /** id заголовка / приложения / meta_ai -> номер страницы */
  heads: Record<string, number>;
  /** страница курсора (номер в документе) */
  current: number;
  total: number;
  masks: Mask[];
  /** время последнего пересчёта и его длительность (мс) - для отладки и тестов */
  at: number;
  ms: number;
  runs: number;
  set: (p: Partial<PagesState>) => void;
}

export const pagesStore = createStore<PagesState>()((set) => ({
  ready: false, main: [], front: [], frontCount: 0, heads: {}, current: 0, total: 0, masks: [], at: 0, ms: 0, runs: 0,
  set: (p) => set(p),
}));

export function usePages<T>(sel: (s: PagesState) => T): T { return useStore(pagesStore, sel); }
